import { Modal } from "react-bootstrap";
import HelperService from "../../Services/HelperService";
import { useState } from "react";

interface CommonModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  url: string;
  fileTitle: string;
}

const CommonModal = ({
  show,
  handleClose,
  title,
  url,
  fileTitle,
}: CommonModalProps) => {
  const [zoom, setZoom] = useState(1);
  const [imageLoading, setImageLoading] = useState(true);

  if (!url) return null;

  const targetForType = `${fileTitle || ""} ${url || ""}`.toLowerCase();

  const isPdf = targetForType.includes(".pdf");
  const isImage =
    targetForType.includes(".jpg") ||
    targetForType.includes(".jpeg") ||
    targetForType.includes(".png") ||
    targetForType.includes(".gif") ||
    targetForType.includes(".webp") ||
    url?.startsWith("blob:") ||
    url?.startsWith("data:image/");
  const isVideo =
    targetForType.includes(".mp4") ||
    targetForType.includes(".mov") ||
    targetForType.includes(".avi") ||
    targetForType.includes(".mkv");

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {(title && HelperService.titleCase(title)) || "View Document"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          height: "85vh",
          background: "#f8fafc",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* ---------- PDF ---------- */}
        {isPdf ? (
          <div style={{ width: "100%", height: "80vh" }}>
            <iframe
              src={url}
              title="PDF Viewer"
              style={{
                border: "none",
                width: "100%",
                height: "100%",
                borderRadius: "8px",
              }}
            />
          </div>
        ) : isImage ? (
          /* ---------- IMAGE ---------- */
          <div
            style={{
              textAlign: "center",
              cursor: "zoom-in",
              width: "100%",
              position: "relative",
            }}
          >
            {imageLoading && (
              <div className="text-center py-4">
                <span
                  className="text-secondary fw-normal d-block"
                  style={{ fontSize: "12px" }}
                >
                  Loading...
                </span>
              </div>
            )}
            <img
              src={url}
              alt={title || "Preview"}
              onClick={() => setZoom(zoom === 1 ? 2 : 1)}
              onLoad={() => setImageLoading(false)}
              onError={() => setImageLoading(false)}
              style={{
                maxWidth: "100%",
                height: "auto",
                display: imageLoading ? "none" : "inline-block",
                transform: `scale(${zoom})`,
                transition: "transform 0.3s ease",
                imageRendering: "auto", // keeps image sharp
              }}
            />

            {!imageLoading && (
              <div
                style={{
                  fontSize: "12px",
                  marginTop: "8px",
                  color: "#64748b",
                }}
              >
                Click image to zoom
              </div>
            )}
          </div>
        ) : isVideo ? (
          /* ---------- VIDEO ---------- */
          <video
            src={url}
            controls
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              borderRadius: "10px",
            }}
          />
        ) : (
          <p>Unsupported file type</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;
